import { REMOVE_FROM_SAVE_FOR_LATER, SAVE_FOR_LATER } from "../constants/saveForLaterConstants";

// Save For Later
export const saveForLater = (id, size) => async (dispatch, getState) => {

    const cartItemsArr = getState().cart.cartItems;
    const productToSave = cartItemsArr.find((i) => i.product === id && i.size === size);

    if (productToSave) {
        dispatch({
            type: SAVE_FOR_LATER,
            payload: {
                ...productToSave, // Copy all existing properties
                brand: productToSave.brand ? productToSave.brand : "", // Ensure brand is a string
            }
        });

        localStorage.setItem('saveForLaterItems', JSON.stringify(getState().saveForLater.saveForLaterItems))
    }
}

// Remove From Save For Later
export const removeFromSaveForLater = (id, size) => async (dispatch, getState) => {

    dispatch({
        type: REMOVE_FROM_SAVE_FOR_LATER,
        payload: {id, size},
    });

    localStorage.setItem('saveForLaterItems', JSON.stringify(getState().saveForLater.saveForLaterItems))
}